import { useState } from "react";
import { Slider } from "@/components/ui/slider";

export const PricingCalculator = () => {
  const [cachet, setCachet] = useState([1000]);
  const agencyPercentage = 0.4; // 40% as middle ground between 30-50%

  const calculateAgencyFee = (amount: number) => {
    return amount * agencyPercentage;
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900">
          Vê quanto podes poupar por trabalho
        </h2>
        <p className="mt-4 text-center text-lg text-gray-600 max-w-2xl mx-auto">
          Agências tiram-te por cada trabalho entre 30% e 50%
        </p>
        
        <div className="mt-8 max-w-xl mx-auto">
          <div className="bg-gray-50 rounded-lg p-8">
            <div className="mb-6">
              <label className="text-lg font-medium text-gray-700 block mb-4">
                Cachet do trabalho: {cachet[0]}€
              </label>
              <div className="px-4 py-2">
                <Slider
                  value={cachet}
                  onValueChange={setCachet}
                  max={5000}
                  min={100}
                  step={100}
                  className="w-full h-6"
                />
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-red-50 rounded-lg">
              <p className="text-red-600 font-semibold text-xl text-center">
                Valor que perdes para a agência: {calculateAgencyFee(cachet[0])}€
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};